import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { KambiSportsSelection } from '@mobi/betslip/types'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'

/** Assumes single bet per coupon, as used in Bet Loop */
export function getKambiCouponBetType(
  coupon: BetLoopKambiShareCoupon | KambiHistoryCoupon
): KambiSportsSelection['betSelectionType'] {
  if (coupon.bets[0].couponRowIndexes.length > 1) {
    return 'multi'
  }

  if (coupon.bets[0].couponRowIndexes.length === 1 && coupon.couponRows[0].outcomeGroup) {
    return 'same-game-multi'
  }

  return 'single'
}
